import { FC } from 'react';
import ISvgProps from '../SvgLoader/ISvgProps';

export const ArrowUpIcon: FC<ISvgProps> = ({ primaryColor = '#535763' }) => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8 7.24216L4.11094 10.7778L3 9.7678L8 5.22222L13 9.7678L11.8891 10.7778L8 7.24216Z"
				fill={primaryColor}
			/>
		</svg>
	);
};
